import {showError} from "../notification/ToastManager";

export const onServerCallError = (summary, details, action) => {
    showError(summary, details)
    action();
}
